/* subscription-consent.js
   1) Blocks cart checkout until the recurring-subscription consent box is ticked.
      The checkbox (.js-sub-consent-trigger) is rendered ONLY when a subscription
      line item is in the cart (snippets/cart.liquid + snippets/popup-cart.liquid),
      so the consent gate never affects non-subscription carts.
   2) Repairs the popup/mini-cart "Proceed to checkout" for ALL carts: the theme
      renders that button outside the cart <form>, so it has no native submit —
      when a checkout button has no owning form, we navigate to /checkout.

   Works on BOTH the full cart page (checkbox + button share a <form>) and the
   popup/mini cart (the theme renders the popup checkout button OUTSIDE any form,
   so we scope by `.popup-cart` instead). Delegated on `document` (capture) so it
   survives the AJAX-rendered popup. CSS (subscription-consent.css) greys the
   button + sets pointer-events:none; this JS is the hard block for keyboard
   activation and browsers without :has() support. Fail-open: if this does not
   run, checkout still works — true enforcement would need Shopify Plus. */
(function () {
  'use strict';

  // The container that holds BOTH the trigger checkbox and the checkout button.
  function scopeFor(el) {
    return el.closest('form') || el.closest('.popup-cart') || el.closest('.template-cart') || document;
  }

  function unconsentedTrigger(scope) {
    if (!scope || !scope.querySelector) return null;
    var trigger = scope.querySelector('.js-sub-consent-trigger');
    return (trigger && !trigger.checked) ? trigger : null;
  }

  function flag(trigger) {
    if (!trigger) return;
    trigger.classList.add('error');
    var wrap = trigger.closest('.subscription-consent');
    if (wrap) wrap.classList.add('error');
    var label = document.querySelector('label[for="' + trigger.id + '"]') || wrap;
    if (label && label.scrollIntoView) label.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // Guard the cart-page form submit (covers Enter-key submission).
  document.addEventListener('submit', function (e) {
    if (!e.submitter || e.submitter.name !== 'checkout') return;
    var trigger = unconsentedTrigger(e.target);
    if (trigger) { e.preventDefault(); e.stopPropagation(); flag(trigger); }
  }, true);

  // Guard the checkout button click. Capture + stopImmediatePropagation so it
  // runs before any theme handler.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn) return;
    var scope = scopeFor(btn);
    var trigger = scope.querySelector('.js-sub-consent-trigger');

    // Subscription cart with consent not yet given → block + prompt.
    if (trigger && !trigger.checked) {
      e.preventDefault(); e.stopImmediatePropagation(); flag(trigger);
      return;
    }

    // Consent satisfied (or not required). The popup/mini-cart checkout button
    // sits OUTSIDE the cart <form> (a pre-existing theme quirk — the form closes
    // after the line items), so it has no native submit and does nothing on
    // click. When the button has no owning form, proceed to checkout ourselves.
    // This repairs the popup checkout for ALL carts. The full cart-page button
    // IS inside its form, so we leave it to submit natively.
    if (!btn.form) {
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = '/checkout';
    }
  }, true);

  // Clear the error highlight once the customer ticks the box.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('js-sub-consent-trigger') && t.checked) {
      t.classList.remove('error');
      var wrap = t.closest('.subscription-consent');
      if (wrap) wrap.classList.remove('error');
    }
  });
})();
